import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Filter, Package, ChevronDown,Search,Calendar } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { Msg200or201, Msg204, Msg400, Msg401, Msg403, Msg500 } from '../../Messages/Messages';
import { decryptData } from "../../../utils/storageCrypto";

export default function SelectOrder({ onOpenFulfillment,onShipmentCreated }) {
  const navigate = useNavigate();

  const [popupItems, setPopupItems] = useState(null);
  const [selectedDate, setSelectedDate] = useState("");
  const dateInputRef = useRef(null);
  const [deliveryshipments, setDeliveryshipments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedDGIds, setSelectedDGIds] = useState([]);
const [popupMessage, setPopupMessage] = useState('');
const [popupType, setPopupType] = useState('');
const [showPopup, setShowPopup] = useState(false);
  const [retryFunction, setRetryFunction] = useState(null);
  const [errorMessages, setErrorMessages] = useState([]);
  const [showMapPopup, setShowMapPopup] = useState(false);
const [mapData, setMapData] = useState({
  address: "",
  lat: null,
  lng: null,
});
const [filteredDeliveryshipments, setFilteredDeliveryshipments] = useState([]);
const [selectedStatus, setSelectedStatus] = useState([]);
const [showStatusDropdown, setShowStatusDropdown] = useState(false);

const STATUS_OPTIONS = [
  "Not Billed",
  "Billed",
  "Partially Billed",
  "Ready To Bill",
  "Waiting for Delivery Schedule",
  "Ready For Delivery",
  "Out For Delivery",
  "Delivered",
  "Returned",
  "Cancelled"
];

const STATUS_COLORS = {
  "Not Billed": "text-red-600 bg-red-50",
  "Billed": "text-green-600 bg-green-50",
  "Partially Billed": "text-yellow-600 bg-yellow-50",
  "Ready To Bill": "text-blue-600 bg-blue-50",
  "Waiting for Delivery Schedule": "text-blue-600 bg-blue-50",
  "Ready For Delivery": "text-teal-700 bg-teal-50",
  "Out For Delivery": "text-purple-600 bg-purple-50",
  "Delivered": "text-green-700 bg-green-50",
  "Returned": "text-red-700 bg-red-50",
  "Cancelled": "text-gray-500 bg-gray-50",
  "Order Confirmed":"text-green-700 bg-green-50",
  "Pending":"text-red-700 bg-red-50"
};

  const handleCloseError = () => {
    setErrorMessages([]);
  };

  const closePopup = () => {

    setShowPopup(false);
  };

  
  
  const Retry = async () => {

    setLoading(true); // Show loader
    setTimeout(async () => {
      if (retryFunction) {
        await retryFunction(); // Call retry function
      }
      setLoading(false); // Hide loader after retry
    }, 5000); // 5-second delay
    setShowPopup(false);
  };
  
  const BackToLoginPage = () => {

    setShowPopup(false);
    localStorage.removeItem('LoginData');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('appId');
  navigate('/bb');
  };

  const fetchDeliveryGroupShipments = async () => {
    setLoading(true);
    try {
      const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);


      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/salesorder/get-deliverygroups-for-shipment`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-token": token,
          },
        }
      );

      const resData = await response.json();
      const orders = resData?.data || [];
      console.log("deliverygroupshipment",orders);

      /* ✅ MAP ORDER → DELIVERY GROUPS (NO FLATTEN) */
      const mappedData = orders.map((order) => ({
        order_id: order._id,
        order_number: order.order_number,
        customer_name: order.customer_name,
        customer_mobile: order.customer_mobile,
        createdAt: order.delivery_groups?.[0]?.created_at
  ? new Date(order.delivery_groups[0].created_at).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
  : "--",

  createdAtRaw: order.delivery_groups?.[0]?.created_at || null,

      delivery_groups: (order.delivery_groups || []).map((dg) => {
  const vendor = dg.sub_orders?.[0]?.vendor_id;

  return {
    _id: dg._id,
    delivery_group_number: dg.delivery_group_number,
    deliveredBy: dg.delivered_to,
    delivery_charges: dg.delivery_charges,
    delivery_group_status: dg.delivery_group_status,

    delivery_date: dg.delivery_date
      ? new Date(dg.delivery_date).toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
      : "--",

    itemsData: dg.sub_orders?.flatMap((so) =>
      (so.items || []).map((item) => ({
        name: item.item_name,
        finalPrice: item.item_total_price,
        awardedTo: item.awarded_to,
        image: item.item_image,
      }))
    ),

    supplier: vendor?.name || "--",

    // ✅ CORRECT ADDRESS
    location: vendor?.address || "--",

    // ✅ CORRECT COORDINATES (FOR MAP)
    lat: vendor?.location?.lat || null,
    lng: vendor?.location?.lng || null,

    vehicleCharge: dg.delivery_vehicle_type || "--",
    subOrderStatus: dg.sub_orders?.[0]?.status || "--",
    billingStatus:dg.sub_orders?.[0]?.billing_status || "--",

    shipmentStatus:
      dg.delivery_shipments?.[0]?.status || "--",
   shipmentId:dg.delivery_shipments?.[0]?._id || null,
    shipmentNo:
      dg.delivery_shipments?.[0]?.delivery_shipment_number || "-",
  };
}),

      }));

      setDeliveryshipments(mappedData);
      setFilteredDeliveryshipments(mappedData);
    } catch (error) {
      console.error("Error fetching deliveryshipment:", error);
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    fetchDeliveryGroupShipments();
  }, []);

  useEffect(() => {
  if (!deliveryshipments.length) return;

  if (!selectedDate) {
    // No date selected - show all
    setFilteredDeliveryshipments(deliveryshipments);
    return;
  }

  // Filter by selected date matching createdAtRaw date part
  const filtered = deliveryshipments.filter((order) => {
    if (!order.createdAtRaw) return false;
    
    const orderDate = new Date(order.createdAtRaw);
    const selected = new Date(selectedDate);
    
    // Compare only date part (ignore time)
    return (
      orderDate.getFullYear() === selected.getFullYear() &&
      orderDate.getMonth() === selected.getMonth() &&
      orderDate.getDate() === selected.getDate()
    );
  });
 setFilteredDeliveryshipments(filtered);
}, [selectedDate, deliveryshipments]);



const toggleStatus = (status) => {
  setSelectedStatus(prev =>
    prev.includes(status)
      ? prev.filter(s => s !== status)
      : [...prev, status]
  );
};

const toggleSelectAll = () => {
  if (selectedStatus.length === STATUS_OPTIONS.length) {
    setSelectedStatus([]);
  } else {
    setSelectedStatus(STATUS_OPTIONS);
  }
};

const clearAll = () => {
  setSelectedStatus([]);
};
useEffect(() => {
  const handleOutside = (e) => {
    if (!e.target.closest(".status-dropdown")) {
      setShowStatusDropdown(false);
    }
  };

  document.addEventListener("mousedown", handleOutside);
  return () => document.removeEventListener("mousedown", handleOutside);
}, []);

  const handleDGSelection = (dgId) => {
  setSelectedDGIds((prev) =>
    prev.includes(dgId)
      ? prev.filter((id) => id !== dgId)
      : [...prev, dgId]
  );
};

const createOrUpdateDeliveryShipment = async () => {
  try {
   const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);
                const encryptedOrganizationId = sessionStorage.getItem('organizationId');
                const organizationid = decryptData(encryptedOrganizationId);

    if (!selectedDGIds.length) {
      setPopupMessage("Please select at least one delivery group");
      setPopupType('400');
      setShowPopup(true);
      return;
    }

    const payload = {
      organizationid,
      deliverydate: new Date().toISOString(), // today date
      dg_ids: selectedDGIds,
    };

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}delivery-shipment/create-or-update-delivery-shipment`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
        body: JSON.stringify(payload),
      }
    );

    const resData = await response.json();
    console.log("create shipment",resData);

    if (!response.ok) {
      setPopupMessage(resData?.message || "Shipment creation failed");
      setPopupType(response.status === 401 ? '401' : response.status === 403 ? '403' : '400');
      setShowPopup(true);
      return;
    }

    setPopupMessage("Shipment created successfully!");
    setPopupType('200or201');
    setShowPopup(true);
    setTimeout(() => {
  setShowPopup(false);
}, 2000);
    // refresh list after creation
    fetchDeliveryGroupShipments();
    if (onShipmentCreated) {
     onShipmentCreated(); 
     }
    setSelectedDGIds([]);

  } catch (error) {
    console.error("Create shipment error:", error);
    setPopupMessage("Network error. Please check your connection and try again.");
    setPopupType('500');
    setShowPopup(true);
  }
};

const hasValidAddress = (addr) =>
  typeof addr === "string" && addr.trim().length > 0 && addr !== "--";

const hasValidCoords = (lat, lng) =>
  typeof lat === "number" && typeof lng === "number";

const openInMap = (locationAddress, lat, lng) => {
  setMapData({
    address: locationAddress,
    lat,
    lng,
  });
  setShowMapPopup(true);
};

const filteredDeliveryshipmentsByStatus = filteredDeliveryshipments.map((order) => {
  // If no status selected → show all delivery groups
  if (selectedStatus.length === 0) return order;

  const filteredGroups = order.delivery_groups.filter((dg) => {
    const subOrderStatus = dg.subOrderStatus?.toLowerCase();
    const billingStatus = dg.billingStatus?.toLowerCase();

    return selectedStatus.some(
      (status) =>
        status.toLowerCase() === subOrderStatus ||
        status.toLowerCase() === billingStatus
    );
  });

  return {
    ...order,
    delivery_groups: filteredGroups,
  };
});

const hasAnyDGAfterStatusFilter = filteredDeliveryshipmentsByStatus.some(
  (order) => order.delivery_groups.length > 0
);

  return (
<div className="border rounded-lg shadow-sm bg-white p-1">
      {/* ================= HEADER ================= */}
      <div className="flex items-center justify-between p-3 ">
        <h2 className="text-md font-semibold">
          Select Order & Create New Shipments
        </h2>

        <div className="flex justify-end items-center gap-2">
          <div className="relative status-dropdown">
          <Filter className="absolute left-3 top-3 w-4 h-4 text-gray-400 pointer-events-none" />
        
          <button
            type="button"
            onClick={() => setShowStatusDropdown(!showStatusDropdown)}
            className="pl-10 pr-8 py-2 border rounded-md text-sm bg-white focus:outline-none  min-w-[220px]  text-left"
          >
            {selectedStatus.length === 0
              ? "All Status"
              : `${selectedStatus.length} Selected`}
        
                <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
          </button>
        
          {showStatusDropdown && (
            <div className="absolute z-20 mt-1 w-full bg-white border rounded-md shadow-lg max-h-[260px] overflow-y-auto">
        
              {/* HEADER */}
              <div className="flex items-center justify-between px-3 py-2 border-b">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={selectedStatus.length === STATUS_OPTIONS.length}
                    onChange={toggleSelectAll}
                  />
                  <span className="text-sm font-medium">All Status</span>
                </label>
        
                <button
                  onClick={clearAll}
                  className="text-xs text-red-600 hover:underline"
                >
                  Clear
                </button>
              </div>
        
              {/* LIST */}
              {STATUS_OPTIONS.map((status) => (
                <label
                  key={status}
                  className="flex items-center gap-2 px-3 py-2 hover:bg-gray-50 cursor-pointer"
                >
                  <input
                    type="checkbox"
                    checked={selectedStatus.includes(status)}
                    onChange={() => toggleStatus(status)}
                  />
                  <span className="text-sm">{status}</span>
                </label>
              ))}
            </div>
          )}
        </div>

         <div
  onClick={() => dateInputRef.current?.showPicker()}
  className="relative flex items-center border rounded-md px-3 py-2 text-sm cursor-pointer min-w-[100px] mr-2"
>
  {!selectedDate && <Calendar className="w-4 h-4 text-gray-400 mr-2" />}
  {selectedDate && (
    <span className="text-gray-700 gap-1">
      {new Date(selectedDate).toLocaleDateString("en-GB")}
    </span>
  )}
  <ChevronDown className="w-4 h-4 text-gray-500 ml-auto" />
  <input
    ref={dateInputRef}
    type="date"
    value={selectedDate}
    onChange={(e) => {
      setSelectedDate(e.target.value);
    }}
    className="absolute inset-0 opacity-0 cursor-pointer"
  />
</div>
        </div>
      </div>

      {/* ================= ORDER SECTIONS ================= */}
<div className="relative max-h-[40vh] overflow-y-auto overflow-x-auto"> 
  {loading ? (
      <div className="text-center py-12 text-gray-500">Loading...</div>
  ) : deliveryshipments.length === 0 ? (
    // 📦 No orders found
    <div className="flex flex-col items-center justify-center min-h-[120px] px-4 border border-dashed border-gray-300 rounded-md mx-6 mb-4">
      <Package className="w-6 h-6 text-gray-400 mb-2" />
      <p className="text-md text-gray-500 text-center leading-relaxed">
        Delivery Groups Not Found
      </p>
    </div>
    ) : filteredDeliveryshipments.length === 0 ? (
    // 📦 No orders found
    <div className="flex flex-col items-center justify-center min-h-[120px] px-4 border border-dashed border-gray-300 rounded-md mx-6 mb-4">
      <Search className="w-6 h-6 text-gray-400 mb-2" />
      <p className="text-md text-gray-500 text-center leading-relaxed">
        No Delivery Groups Found for the Selected Date.
        Try adjusting your filter.
      </p>
    </div>
    ) : !hasAnyDGAfterStatusFilter ? (
  // 🚫 No delivery groups for selected status
  <div className="flex flex-col items-center justify-center min-h-[120px] px-4 border border-dashed border-gray-300 rounded-md mx-6 mb-4">
    <Search className="w-6 h-6 text-gray-400 mb-2" />
    <p className="text-md text-gray-500 text-center leading-relaxed">
      No Delivery Groups Found for the selected status.
      <br />
      <span className="text-sm text-gray-400">
        Try adjusting your filter.
      </span>
    </p>
  </div>
  ) : (
    // ✅ Render orders
    filteredDeliveryshipmentsByStatus.map((order) => (
      <div key={order.order_id} className="mb-4 mt-4 mx-2 border rounded-lg overflow-hidden">
        {/* ===== ORDER HEADER (ONCE) ===== */}
        <div className="p-4 border-b bg-white">
          <div className="flex flex-wrap justify-between gap-4 text-sm">
            <div>
              <p className="font-semibold">{order.order_number}</p>
              <p className="text-gray-500">Created At : {order.createdAt}</p>
            </div>

            <div>
              <p>
                <span className="text-gray-500">Customer :</span>{" "}
                <span className="font-medium">{order.customer_name}</span>
              </p>
              <p>
                <span className="text-gray-500">Mobile :</span>{" "}
                {order.customer_mobile}
              </p>
            </div>

         <div className="flex items-center text-sm font-medium text-gray-700 ">
  Status :
 <span
  className={`ml-1 px-3 py-1 rounded-full text-sm font-semibold ${
    STATUS_COLORS[order.delivery_groups?.[0]?.subOrderStatus] ||
    "text-gray-600"
  }`}
>
    {order.delivery_groups?.[0]?.subOrderStatus || "--"}
  </span>
</div>


          </div>
        </div>

        {/* ===== TABLE (MULTIPLE DG ROWS) ===== */}
        <div className="overflow-x-auto">
          <table className="min-w-full table-fixed divide-y divide-gray-200">
            <thead className="bg-[#fafafc] text-[#6c7184] text-xs uppercase">
              <tr className='border-b'>
                <th className="px-2 py-3 text-center"><input type="checkbox" /></th>
                <th className="px-4 py-3 text-center">DG No</th>
                <th className="px-4 py-3 text-center">Delivered To</th>
                <th className="px-4 py-3 text-center">Delivery Time</th>
                <th className="px-4 py-3 text-center">Items</th>
                <th className="px-4 py-3 text-center">Supplier</th>
                <th className="px-4 py-3 text-center">Location</th>
              <th className="px-4 py-3 text-center  min-w-[140px]">
               Vehicle & Charge
               </th>
                <th className="px-4 py-3 text-center">Status</th>
                <th className="px-4 py-3 text-center">Shipment Status</th>
                <th className="px-4 py-3 text-center">Shipment Number</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {order.delivery_groups.map((d) => (
                <tr key={d._id}>
                  <td className="px-2 py-3 text-center">
                    <input
                      type="checkbox"
                      disabled={!!d.shipmentNo && d.shipmentNo !== "-"}
                      checked={selectedDGIds.includes(d._id)}
                      onChange={() => handleDGSelection(d._id)}
                    />
                  </td>
                  <td className="px-4 py-3 text-sm text-center">{d.delivery_group_number}</td>
                  <td className="px-4 py-3 text-sm text-center">{d.deliveredBy}</td>
                  <td className="px-4 py-3 text-center text-sm">{d.delivery_date}</td>
                  <td className="px-4 py-3 text-center text-sm">
                    <span
                      className="text-blue-600 cursor-pointer hover:underline"
                      onClick={() => { if(d.itemsData?.length) setPopupItems(d.itemsData); }}
                    >
                      {d.itemsData?.length || 0}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-center text-sm">{d.supplier}</td>
              <td className="px-4 py-3 text-sm text-center">
  {(hasValidAddress(d.location) || hasValidCoords(d.lat, d.lng)) ? (
    <div
      onClick={() => openInMap(d.location, d.lat, d.lng)}
      className="flex items-center justify-center gap-1 cursor-pointer text-blue-600"
      title={hasValidAddress(d.location) ? d.location : "View on map"}
    >
      <FontAwesomeIcon
        icon={faMapMarkerAlt}
        className="text-blue-600 flex-shrink-0 mt-1"
      />
      {hasValidAddress(d.location) && (
        <span
          className="text-center max-w-[120px] overflow-hidden text-ellipsis"
          style={{
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
          }}
        >
          {d.location}
        </span>
      )}
    </div>
  ) : (
    <span className="text-gray-400 text-center">--</span>
  )}
</td>



                 <td className="px-4 py-3 text-center text-sm">
                    <div>{d.vehicleCharge}</div>
                     <div> ₹{d.delivery_charges}</div>
                  </td>
                 <td className="px-4 py-3 text-center text-xs min-w-[120px]">
  <span
    className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${
      STATUS_COLORS[d.delivery_group_status] || "text-gray-600 bg-gray-100"
    }`}
  >
    {d.delivery_group_status || "--"}
  </span>
</td>

                   <td className="px-4 py-3 text-center text-sm">
                     <span
                   className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${
                   STATUS_COLORS[d.shipmentStatus] || "text-gray-600 bg-gray-100"
                     }`}
                       >
                     {d.shipmentStatus || "--"}
                    </span>
                        </td>
                  <td
                    className="px-4 py-3 text-center text-sm text-blue-600 cursor-pointer hover:underline"
                    onClick={() => {
                 if (!d.shipmentId) return;
                   onShipmentCreated?.();     // refresh shipmentdata first
               onOpenFulfillment(d.shipmentId);
                   }}
                  >
                    {d.shipmentNo}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    ))
  )}
</div>

      {/* ================= FOOTER ================= */}
     {deliveryshipments.length > 0 && (
  <div className="p-3 flex justify-end border-t">
    <button
      onClick={createOrUpdateDeliveryShipment}
      className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
    >
      + Create Shipment
    </button>
  </div>
)}

      {/* ================= POPUP (UNCHANGED) ================= */}
     {popupItems && (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg p-6 w-[750px] max-h-[80vh] overflow-auto relative">
      <button
        className="absolute top-6 right-6 text-gray-600 hover:text-gray-800"
        onClick={() => setPopupItems(null)}
      >
        ✕
      </button>

      <h3 className="font-semibold text-lg mb-4">Items Details</h3>

      <table className="min-w-full border border-gray-300">
        <thead className="bg-gray-100 border-b border-gray-300">
          <tr>
            <th className="px-3 py-2 border-r border-gray-300">Item Image</th>
            <th className="px-3 py-2 border-r border-gray-300">Item Name</th>
            <th className="px-3 py-2 border-r border-gray-300">Final Price</th>
            <th className="px-3 py-2">Awarded To</th>
          </tr>
        </thead>
        <tbody>
          {popupItems.map((item, idx) => (
            <tr key={idx} className="border-b border-gray-300">
              <td className="px-3 py-3 text-center border-r border-gray-300">
               {item.image ? (
  <div className="w-12 h-12 mx-auto bg-gray-100 rounded-md overflow-hidden flex items-center justify-center">
    <img
      src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + item.image}
      alt={item.name}
      className="w-10 h-10 object-cover"
    />
  </div>
) : (
  <div className="w-12 h-12 mx-auto bg-gray-100 rounded-md flex flex-col items-center justify-center text-center">
    <span className="text-[10px] leading-tight text-gray-500">
      No
    </span>
    <span className="text-[10px] leading-tight text-gray-500">
      Image
    </span>
  </div>
)}

              </td>
              <td className="px-3 py-3 text-center border-r border-gray-300">{item.name}</td>
              <td className="px-3 py-3 text-center border-r border-gray-300">{item.finalPrice}</td>
              <td className="px-3 py-3 text-center">{item.awardedTo}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)}

{showMapPopup && (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg w-[700px] max-w-[90%] p-4 relative">
      
      {/* Close */}
      <button
        className="absolute top-3 right-3 text-gray-600 hover:text-gray-800"
        onClick={() => setShowMapPopup(false)}
      >
        ✕
      </button>

      <h3 className="font-semibold text-lg mb-2">Supplier Location</h3>

      {/* Address */}
      {mapData.address && (
        <p className="text-sm text-gray-600 mb-3">
          📍 {mapData.address}
        </p>
      )}

      {/* MAP */}
      <div className="w-full h-[400px] rounded overflow-hidden border">
        <iframe
          title="map"
          width="100%"
          height="100%"
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          src={
            mapData.lat && mapData.lng
              ? `https://www.google.com/maps?q=${mapData.lat},${mapData.lng}&output=embed`
              : `https://www.google.com/maps?q=${encodeURIComponent(
                  mapData.address
                )}&output=embed`
          }
        />
      </div>
    </div>
  </div>
)}


 {showPopup && (
  <div>
    {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={2000} />}
    {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
    {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
          {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup} />}
  </div>
)}

    </div>
  );
}
